// components/SuperAdminRoute.js
import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const SuperAdminRoute = ({ children }) => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const isSuperuser = useSelector((state) => state.auth.isSuperuser);

  if (!isAuthenticated) return <Navigate to="/" />;
  if (!isSuperuser) return <Navigate to="/dashboard" />;
  return children;
};

export default SuperAdminRoute;
